// import * as Sentry from "@sentry/browser";

export function logError(error, errorInfo = null) {
  console.log("error: ", error);
  // console.log("error: ", JSON.stringify(error));
  // Sentry.withScope((scope) => {
  //   errorInfo && scope.setExtras(errorInfo);

  //   // capture AWS Amplify errors
  //   error.data && scope.setExtra("data", error.data);
  //   error.provider && scope.setExtra("data", error.provider);
  //   if(error.errors) return error.errors.forEach(err => {
  //     Sentry.setExtra('error', err);
  //     Sentry.captureException(new Error(err.errorType || err.message));
  //   });
  //   if(error.error && error.error.errors) return error.error.errors.forEach(err => {
  //     Sentry.setExtra('error', err);
  //     Sentry.captureException(new Error(err.errorType || err.message));
  //   });
    
  //   Sentry.captureException(error);
    
  //   // const wrappedError = (error instanceof Error || typeof error === 'string') ? error : new Error(JSON.stringify(error));
  //   // Sentry.captureException(wrappedError);
  // });
}